import { useEffect, useState } from 'react';

/** Online-only product — show a clear banner when the network is unavailable. */
export function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== 'undefined' ? !navigator.onLine : false,
  );

  useEffect(() => {
    function onOffline() {
      setOffline(true);
    }
    function onOnline() {
      setOffline(false);
    }
    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);
    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="offline-banner" role="status" data-testid="offline-banner">
      You are offline. Spox needs a network connection — changes cannot be saved until you
      reconnect.
    </div>
  );
}
